import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <span className="logo-text">
            <span className="logo-letter">W</span>
            <span className="logo-letter">N</span>
            <span className="logo-letter">A</span>
          </span>
          <span className="logo-letter logo-text"> Technology</span>
        </Link>
        <button 
          className="navbar-toggler shadow-none border-0" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto text-center">
            <li className="nav-item my-2 my-lg-0">
              <Link className="nav-link px-3" to="/">Home</Link>
            </li>
            <li className="nav-item my-2 my-lg-0">
              <Link className="nav-link px-3" to="/services">Services</Link>
            </li>
            <li className="nav-item my-2 my-lg-0">
              <Link className="nav-link px-3" to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar; 